import React, { useEffect, useState } from "react";
import localizationService from "../../services/localization-service";
import { useSelector } from "react-redux";

const ModalDeselectGroupInfo = (props) => {
  const selectedlang = useSelector((state) => state.account.lang);
  const group = props.group;
  const day = props.day;
  const selectedStartWeek = props.selectedStartWeek;
  const requestType = props.requestType;
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 1300) {
      setIsDesktopResolution(false);
    }
  }, []);

  return (
    <div
      className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50"
      style={props.openModal ? { display: "flex" } : { display: "none" }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div
          className="px-6 py-4 border-b border-gray-200"
          style={{ position: "relative" }}
        >
          <h3 className="text-lg font-medium text-gray-900">
            {localizationService.getLocalizationValue(
              "modalDeselectGroupTitle",
              selectedlang,
            )}
          </h3>
          <i
            className="fas fa-times"
            style={{ position: "absolute", top: "5px", right: "6px" }}
            onClick={props.closeModal}
          ></i>
        </div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500">
            {localizationService.getLocalizationValue(
              "modalDeselectGroupMessagePart1",
              selectedlang,
            )}{" "}
            <b>"{group}"</b>{" "}
            {localizationService.getLocalizationValue(
              "modalDeselectGroupMessagePart2",
              selectedlang,
            )}
            {day}
            {requestType == 1 ? (
              <>
                {localizationService.getLocalizationValue(
                  "modalDeselectGroupMessagePart4",
                  selectedlang,
                )}
                {selectedStartWeek}
              </>
            ) : (
              <></>
            )}
            .
          </p>
          <p className="text-sm text-gray-500">
            {localizationService.getLocalizationValue(
              "modalDeselectGroupMessagePart3",
              selectedlang,
            )}
          </p>
        </div>
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={props.closeModal}
            className={`inline-flex ${!isDesktopResolution ? "w-[100%]" : "w-[70%]"} justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:!bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200`}
          >
            {localizationService.getLocalizationValue("close", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDeselectGroupInfo;
